import classNames from 'classnames'
import { TProductParams } from 'feature/appeals/type'
import { ChangeEvent, FC, memo, useRef, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { TextField } from 'ui'
import { LoaderInCentalPosition } from 'widget'

import style from './InputText.module.scss'

interface IInputText {
  parameter: TProductParams
  type?: string
}

// InputImages - параметр продукта с типом text/number

export const InputText: FC<IInputText> = memo(({ parameter, type }) => {
  const { control } = useFormContext()
  const InputRef = useRef<HTMLInputElement | null>(null)
  const [isImageError, setImageError] = useState<boolean>(false)
  const [isImageLoading, setImageLoading] = useState<boolean>(true)

  const onErrorImg = () => {
    setImageError(true)
    setImageLoading(false)
  }

  const onLoadImg = () => {
    setImageLoading(false)
  }

  const { name, id, parameterValue, iconUrl } = parameter

  return (
    <Controller
      name={`${id}`}
      control={control}
      defaultValue={parameterValue?.value || null}
      render={({ field, fieldState }) => {
        const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
          let targetValue: string | number = e.target.value

          if (type === 'number' && targetValue === '') {
            field.onChange(null)
            return
          }

          if (type === 'number') {
            targetValue = +e.target.value.replace(/[^0-9]/g, '')
          }

          field.onChange(targetValue)
        }

        return (
          <div className={style.inputTextWithIcon}>
            {isImageLoading && <LoaderInCentalPosition />}

            <img
              src={iconUrl}
              alt={name}
              className={classNames(
                style.productImg,
                !isImageLoading && style.productImgVisible,
                isImageError && style.productImgError,
              )}
              onError={onErrorImg}
              onLoad={onLoadImg}
              loading='lazy'
            />

            <TextField
              {...field}
              className={style.textField}
              inputRef={InputRef}
              error={Boolean(fieldState?.error)}
              label={name}
              inputProps={{
                maxLength: type === 'number' ? 15 : 255,
                autoComplete: 'off',
              }}
              type={type === 'number' ? 'tel' : 'text'}
              onChange={handleChange}
            />
          </div>
        )
      }}
    />
  )
})
